import { status } from '../../config.ts'
import { wait } from '@/__mocks__/util/async.ts'
import {
  updatePassword,
  validateTokenRequest
} from '@/__mocks__/modules/setPassword/data.ts'

export default [
  {
    method: 'POST',
    path: '/validate-token',
    reply: async () => {
      await wait()
      return [status.ok, validateTokenRequest]
    }
  },
  {
    // There is a method with same url in 'recovery'. Probably the one being used.
    method: 'POST',
    path: '/update-password',
    reply: async () => {
      await wait()
      return [status.ok, updatePassword]
    }
  }
]
